import {AfterViewInit, Component, Inject, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {FullChild} from "../../../../interfaces/FullChild";
import {CentreService} from "../../../../services/centre.service";
import {ChildService} from "../../../../components/child/child.service";
import {QuestionsService} from "../../../questions/questions.service";
import {MatSelectChange} from "@angular/material/select";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {ActivatedRoute} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {EducationService} from "../../education.service";
import firebase from "firebase/compat/app";
import dateutil from "rrule/dist/esm/src/dateutil";
import sort = dateutil.sort;
import {QuestionModel} from "../../../../interfaces/QuestionModel";

@Component({
    selector: 'app-follow-up-question',
    templateUrl: './follow-up-question.component.html',
    styleUrls: ['./follow-up-question.component.scss']
})
export class FollowUpQuestionComponent implements OnInit,AfterViewInit,OnDestroy {
    env = isDevMode() ? environment.testMode : environment.productionMode;
    private _destroyed$ = new Subject<void>();
    selectedCentre = ''
    _centres$: Observable<Centre[]>
    childBycentre!: Observable<any[]>;
    selectedChildCode: any;
    filteredChildren: any[] =[]
  selectedChildrenList: any[] = [];
    questionList!: any[];
    selectedChild: any = null;
    displayChild = (c: any): string => {return c ? `${c.childName}` : '';};

  selectedAnswers: any;
    questionArray: any[] = [];
    answersObject: any;
    form!: FormGroup<any>
    id?: string | null
    dateOfAssessment!: Date;
    assessmentTypes: string[] = [];
  editMode = false
    userdata: any
mData:any
  attendingIndex = 0;          // first question
  highlightIndex!: number;     // will detect dynamically
    constructor(private readonly centreService: CentreService,
                private childService: ChildService,
                private mService: QuestionsService,
                private readonly mDialogRef: MatDialogRef<FollowUpQuestionComponent>,
                private fb: FormBuilder,
                private router: ActivatedRoute,
                private  mEducationService: EducationService,
                private mFirestore: AngularFirestore,
                @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.userdata = JSON.parse(localStorage.getItem('userData')!)
if(data) this.mData =data
// if(this.data!=null) alert(JSON.stringify(this.data))
        this._centres$ = this.centreService.getAllCentres()

        // this.router.paramMap.subscribe(res => {
        //     this.id = res.get('id')

            this.form = this.fb.group({
                centreCode: new FormControl(null, Validators.required),
                centreName: new FormControl(null, Validators.required),
                childName: new FormControl(null, Validators.required),
                childCode: new FormControl(null, Validators.required),
                sessionType: new FormControl(null, Validators.required),
                date: new FormControl(null, Validators.required),
                createdAt: new FormControl(new Date(), Validators.required),
                questions: new FormArray([],),
            })

            this.mService.getEducationQuestionList().pipe(takeUntil(this._destroyed$)).subscribe(res => {
                this.questionList = res
              this.highlightIndex = this.questionList.findIndex(
                q => q.question === 'Any highlighted points to be shared'
              );
                console.log(this.questionList)
                if (this.data == null) this.setupQuestions(this.questionList)

            })



            if (this.data != null) {
                // alert(this.id)

                this.editMode =true
                // this.mFirestore.collection(this.env.educationFollowUp).doc(this.id!!).get().subscribe(res => {
                //     let data = res.data() as any
                //     this.mData =data
                    // alert(JSON.stringify(data))
                    let formDate = data?.date;
                    if (data?.date && typeof data.date.toDate === 'function') {
                        formDate = data.date.toDate();
                    } else if (typeof data?.date === 'string') {
                        formDate = new Date(data.date);
                    }

                    this.form.patchValue({
                        date: formDate,
                        sessionType: data?.sessionType,
                        centreName: data?.centreName,
                        centreCode: data?.centreCode,
                        childName: data?.childName,
                        childCode: data?.childCode
                    });

                    // this.form.get('questions')?.setValue(data?.questions)
                    let array = this.form.get('questions') as FormArray

                    data?.questions.forEach((q: any) => {
                        console.log(q)
                        array.push(new FormGroup({
                            question: new FormControl(q.question),
                            ans: new FormControl(q.ans||''),
                            remark: new FormControl(q.remark || ''),
                            remarkDropdown: new FormControl(q.remarkDropdown || ''),
                            dropdownLabel: new FormControl(q.dropdownLabel || '')
                        }))

                    })

                // })
            }

        // })

      // alert(JSON.stringify(questions))

    }

  ngAfterViewInit(): void {

  }

    ngOnInit(): void {


    }
  shouldShowQuestion(index: number): boolean {
    if (!this.formArray || this.formArray.length === 0) {
      return false;
    }

    const first = this.formArray.at(0);
    const attendingAns = first?.get('ans')?.value;

    // Always show first question
    if (index === 0) {
      return true;
    }

    // If attending = No → show ONLY highlight
    if (attendingAns === 'No') {
      return index === this.highlightIndex;
    }

    // If attending = Yes → show ALL
    if (attendingAns === 'Yes') {
      return true;
    }

    return false;
  }


  onCentreSelect($event: MatSelectChange) {
    let c = $event.value as Centre
    console.log(JSON.stringify(c))
    this.form.get('centreName')?.setValue(c.centreName)
    this.form.get('centreCode')?.setValue(c.centreCode)
    // console.log(this.selectedCentre)
  this.mFirestore.collection(this.env.child ,ref => {
      return ref.where('centreCode','==',$event.value.centreCode)}).get().pipe(takeUntil(this._destroyed$)).subscribe(res=>{
        this.filteredChildren = res.docs.map(x=>
        {
          const doc = x.data() as FullChild
          let obj = {
            childName: doc.firstName + ' ' + doc.lastName,
            centreName: doc.centreName,
            centreCode: doc.centreCode,
            childCode: doc.childCode
          };
          return obj
        })
    });
  }
  onCentreSelect2($event: MatSelectChange) {

        let c = $event.value as Centre
        console.log(JSON.stringify(c))
        this.form.get('centreName')?.setValue(c.centreName)
        this.form.get('centreCode')?.setValue(c.centreCode)
        // console.log(this.selectedCentre)
        this.childBycentre = this.mEducationService.dischargeAssssmentSessionChildren($event.value.centreCode)
        //*TODO: here we want children who are admitted in last sixty days (only where admissionData.length>2)
        const currentDate = new Date();
        const currentDate2 = new Date();

        currentDate2.setDate(currentDate2.getDate()-60);
        // *Convert the date to Firestore Timestamp
        const timestamp = firebase.firestore.Timestamp.fromDate(currentDate2);
        const currentTimestamp = firebase.firestore.Timestamp.fromDate(currentDate);
this.mFirestore.collection<FullChild>(this.env.child,ref => ref.where('centreCode','==',$event.value.centreCode)).get()
    .pipe(takeUntil(this._destroyed$))
    .subscribe(res => {
        this.filteredChildren=[]
const temparray:any[]=[]
let childDocs:FullChild[] = res.docs.map(x=>x.data())
      childDocs.forEach((doc: FullChild) => {
        doc.admissionData.forEach((ad, index: number) => {

          if (
            index % 2 != 0 &&
            ad.dateOfDischarge &&
            ad.dateOfDischarge.toDate() >= currentDate2
          ) {
            let obj = {
              childName: doc.firstName + ' ' + doc.lastName,
              centreName: doc.centreName,
              centreCode: doc.centreCode,
              childCode: doc.childCode
            };
            if (temparray.filter(x => x.childCode == doc.childCode).length == 0)
              temparray.push(obj);
          }

          if (
            index % 2 == 0 &&
            ad.dateOfAdmission &&
            ad.dateOfAdmission.toDate() >= currentDate2
          ) {
            let obj = {
              childName: doc.firstName + ' ' + doc.lastName,
              centreName: doc.centreName,
              centreCode: doc.centreCode,
              childCode: doc.childCode
            };
            if (temparray.filter(x => x.childCode == doc.childCode).length == 0)
              temparray.push(obj);
          }

        });
      });

        // const originalArray = [1, 2, 3, 2, 4, 1];
        // this.filteredChildren = new Array(this.filteredChildren);

        this.filteredChildren = [...new Set(temparray)];
        this.filteredChildren.sort((a, b) => a.childName.localeCompare(b.childName));

      console.log(this.filteredChildren); // Output: [1, 2, 3, 4]
    })


        // console.log(this.filteredChildren)
    }
  searchChild(childCode: string) {
    console.log(childCode)
    this.processChild(childCode);
  }
  processChild(child: any) {

    console.log('Selected child:', child);

    const exists = this.selectedChildrenList.some(
      c => c.childCode === child.childCode
    );

    if (exists) {
      console.log('Child already added');
      return;
    }

    this.selectedChildrenList.push({
      ...child,
      assessmentType: ''
    });

    this.form.get('childName')?.setValue(child.childName);
    this.form.get('childCode')?.setValue(child.childCode);

    this.mFirestore
      .collection(this.env.educationFollowUp, ref =>
        ref
          .where('childCode', '==', child.childCode)
          .orderBy('createdAt', 'asc')
      )
      .get()
      .pipe(takeUntil(this._destroyed$))
      .subscribe(snapshot => {

        const count = snapshot.size;

        this.generateAssessmentTypes(count);
      });

    this.editMode = false;
  }

  generateAssessmentTypes(total: number) {
    this.assessmentTypes = [];

    // Allow next assessment only
    const nextAssessmentNo = total + 1;

    this.assessmentTypes.push(
      `Follow Up Assessment ${nextAssessmentNo}`
    );

    // Auto select it
    this.form.get('sessionType')?.setValue(
      this.assessmentTypes[0]
    );
  }


get getQuestionsArray() {
    return this.form.get('questions') as FormArray;
}

getHighlightQuestion() {
    const questions = this.getQuestionsArray.value;
    return questions.length > 0 ? questions[questions.length - 1] : null;
}

  Submit() {
        //SAVE
        this.form.addControl('submittedBy', new FormControl(this.userdata.userName))

        // Debug form validity
        if (this.form.invalid) {
          console.log('Form is invalid!');
          console.log('Form errors:', this.form.errors);
          console.log('Form value:', this.form.value);

          // Check each question
          this.formArray.controls.forEach((ctrl, i) => {
            if (ctrl.invalid) {
              console.log(`Question ${i} is invalid:`, this.questionList[i].question);
              console.log('Errors:', ctrl.errors);
              console.log('Value:', ctrl.value);
            }
          });

          // Mark all as touched to show validation errors
          this.form.markAllAsTouched();
          return;
        }

        const lastQuestion = this.getHighlightQuestion();
        if (lastQuestion && lastQuestion.ans === 'Yes') {
            this.form.addControl('isHighlight', new FormControl(true));
        } else {
            this.form.addControl('isHighlight', new FormControl(false));
        }

        if (this.data == null) this.mEducationService.addFollowUpAssessment(this.form.value).then(res => {
            console.log("Data submitted Successfully")
            this.mDialogRef.close()
        })
        //UPDATE
        else  this.mFirestore.collection(this.env.educationFollowUp).doc(this.data.id).update(this.form.value).then(res => {
            console.log("Data submitted Successfully")
            this.mDialogRef.close()

        })
    }

cancel(){
    this.mDialogRef.close()

}

  setupQuestions(questionList: any[]) {
    questionList.forEach(question => {
      // Determine validators based on hideRemark
      const remarkValidators = question.hideRemark === true ? [] : [Validators.required];
      const ansValidators = question.isRadioBtn ? [Validators.required] : [];
      const dropdownValidators = question.remarkType === 'dropdown' ? [Validators.required] : [];

      this.formArray.push(
        new FormGroup({
          question: new FormControl(question.question),
          ans: new FormControl('', ansValidators),
          remark: new FormControl('', remarkValidators),
          remarkType: new FormControl(question.remarkType || 'text'),
          hideRemark: new FormControl(question.hideRemark ?? false),
          dropdownLabel: new FormControl(question.dropdownLabel || ''),
          remarkDropdown: new FormControl('', dropdownValidators)
        })
      );
    });
  }


    get formArray() {
        return this.form.get('questions') as FormArray
    }

  onAnswerChange(index: number) {
    const attendingAns = this.formArray.at(0).get('ans')?.value;

    if (attendingAns === 'No') {
      this.formArray.controls.forEach((ctrl, i) => {
        if (i !== 0 && i !== this.highlightIndex) {
          this.disableQuestion(ctrl as FormGroup);
        }
      });
    }

    if (attendingAns === 'Yes') {
      this.formArray.controls.forEach((ctrl, i) => {
        this.enableQuestion(ctrl as FormGroup, i);
      });
    }
  }


  //
  // disableQuestion(group: FormGroup) {
  //   group.get('ans')?.reset();
  //   group.get('remark')?.reset();
  //   group.get('remarkDropdown')?.reset();
  //
  //   group.get('ans')?.clearValidators();
  //   group.get('remark')?.clearValidators();
  //   group.get('remarkDropdown')?.clearValidators();
  //
  //   group.disable();
  //   group.updateValueAndValidity();
  // }
  //
  // enableQuestion(group: FormGroup) {
  //   group.enable();
  //   group.get('ans')?.setValidators([Validators.required]);
  //   group.get('remark')?.setValidators([Validators.required]);
  //
  //   group.updateValueAndValidity();
  // }
  disableQuestion(group: FormGroup) {
    // Clear values
    group.get('ans')?.reset();
    group.get('remark')?.reset();
    group.get('remarkDropdown')?.reset();

    // Clear validators
    group.get('ans')?.clearValidators();
    group.get('remark')?.clearValidators();
    group.get('remarkDropdown')?.clearValidators();

    // Update validity
    group.get('ans')?.updateValueAndValidity();
    group.get('remark')?.updateValueAndValidity();
    group.get('remarkDropdown')?.updateValueAndValidity();
  }

  enableQuestion(group: FormGroup, questionIndex: number) {
    // Get the actual question configuration
    const questionConfig = this.questionList[questionIndex];

    // Set validators for radio button answer (Yes/No)
    if (questionConfig.isRadioBtn) {
      group.get('ans')?.setValidators([Validators.required]);
      group.get('ans')?.updateValueAndValidity();
    } else {
      group.get('ans')?.clearValidators();
      group.get('ans')?.updateValueAndValidity();
    }

    // Handle dropdown questions
    if (questionConfig.remarkType === 'dropdown') {
      group.get('remarkDropdown')?.setValidators([Validators.required]);
      group.get('remarkDropdown')?.updateValueAndValidity();
    } else {
      group.get('remarkDropdown')?.clearValidators();
      group.get('remarkDropdown')?.updateValueAndValidity();
    }

    // Handle remark field - only required if it's visible in the UI
    const isTextType = questionConfig.remarkType === 'text';
    const isDropdownWithRemark = questionConfig.remarkType === 'dropdown' && questionConfig.hideRemark === false;
    
    if (isTextType || isDropdownWithRemark) {
      group.get('remark')?.setValidators([Validators.required]);
      group.get('remark')?.updateValueAndValidity();
    } else {
      group.get('remark')?.clearValidators();
      group.get('remark')?.updateValueAndValidity();
    }
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
